import { api } from '../instance';
export const logout = () => {
    return api.post('/auth/logout');
};
//# sourceMappingURL=logout.api.js.map